export function formatSourceToastStackHint(params: {
  isScrollable: boolean
  hiddenAbove: number
  hiddenBelow: number
}): string {
  if (!params.isScrollable) {
    return ''
  }
  if (params.hiddenAbove === 0 && params.hiddenBelow === 0) {
    return 'Faites défiler pour parcourir la pile'
  }
  return joinStackHintParts(params.hiddenAbove, params.hiddenBelow)
}

function olderNotificationsHint(count: number): string | null {
  if (count <= 0) {
    return null
  }
  const plural = count > 1 ? 's' : ''
  return `↑ ${count} notification${plural} plus ancienne${plural}`
}

function newerNotificationsHint(count: number): string | null {
  if (count <= 0) {
    return null
  }
  const plural = count > 1 ? 's' : ''
  return `↓ ${count} autre${plural} en dessous`
}

function joinStackHintParts(hiddenAbove: number, hiddenBelow: number): string {
  return [olderNotificationsHint(hiddenAbove), newerNotificationsHint(hiddenBelow)]
    .filter((part): part is string => part != null)
    .join(' · ')
}
